import { useRef } from "react";

export function useForbiddenWithLogoutController(){

  const logOut = useRef(() => {
    window.location.href = `/auth_customer/logout?redirect_uri=${encodeURIComponent(window.location.href)}`
  });

  return {
    logOut: logOut.current,
  }
}